import { render, staticRenderFns } from "./AssignMadrillasModal.vue?vue&type=template&id=bf8bcd46"
import script from "./AssignMadrillasModal.vue?vue&type=script&lang=js"
export * from "./AssignMadrillasModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports